import {reducer as loginModal} from '~library/organisms/LoginModal/reducer';
import {reducer as details} from './details/reducer';
import {reducer as giftingOptions} from '~/common/fabric/reducers/giftingOptions/reducer';
import {reducer as guests} from '~/common/fabric/EventGuests/reducers/guests/reducer';
import {reducer as review} from '~/common/fabric/reducers/review/reducer';
import {reducer as fabricTemplate} from './fabricTemplate/reducer';
import {reducer as fabricDesign} from './fabricDesign/reducer';
import {reducer as eviteEvent} from '~/common/fabric/reducers/eviteEvent/reducer';
import {reducer as user} from '~/common/fabric/User/reducers/user/reducer';
import {reducer as modals} from './modals/reducer';
import {reducer as webview} from './webview/reducer';
import {reducer as widgets} from '~/common/fabric/reducers/widgets/reducer';
import {reducer as snapshot} from '~/common/fabric/Snapshot/reducers';
import {reducer as donation} from '~/ViewInvitation/reducers/donation';
import {reducer as cachedMedia} from '~/common/reducers/cachedMedia';
import {api as cartApi} from '~/CreateFabricInvitation/api/api';
import {api as oneStepApi} from '~/OneStepCreateInvitation/api/api';
import {api as viewInvitationApi} from '~/ViewInvitation/api/api';
import {api as guestsApi} from '~/common/fabric/EventGuests/api/api';

export const rootReducer = {
  [cartApi.reducerPath]: cartApi.reducer,
  [oneStepApi.reducerPath]: oneStepApi.reducer,
  [viewInvitationApi.reducerPath]: viewInvitationApi.reducer,
  [guestsApi.reducerPath]: guestsApi.reducer,
  details,
  fabricDesign,
  fabricTemplate,
  giftingOptions,
  guests,
  loginModal,
  eviteEvent,
  user,
  review,
  modals,
  webview,
  widgets,
  snapshot,
  cachedMedia,
  // for invitation preview
  donation,
  moduleOrder: (state = {}) => state,
  eventDetails: (state = {}) => state,
  coverData: (state = {}) => state,
  rsvp: (state = {}) => state,
  gifting: (state = {}) => state,
  registry: (state = {}) => state,
  poll: (state = {}) => state,
  giftKeywords: (state = {}) => state,
  whatToBring: (state = {}) => state,
  whatToBringSummary: (state = {}) => state,
  guestList: (state = {}) => state,
  whoIsComing: (state = {}) => state,
  premiumDesign: (state = {}) => state,
  photos: (state = {}) => state,
};
